import Home from "@/pages/home";

export default function OiWorkspacePage() {
  return <Home />;
}

